(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[260],{

/***/ 6176:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(4836);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(4938));

var _jsxRuntime = __webpack_require__(5893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"
}), 'ArrowForwardIos');

exports.Z = _default;

/***/ }),

/***/ 8:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(5177);
moment.tz.load(__webpack_require__(1128));


/***/ }),

/***/ 5177:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.44
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if ( true && module.exports) {
		module.exports = factory(__webpack_require__(381)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(381)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.44",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	function closest (num, arr) {
		var len = arr.length;
		if (num < arr[0]) {
			return 0;
		} else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) {
			return len - 1;
		} else if (num >= arr[len - 1]) {
			return -1;
		}
	
		var mid;
		var lo = 0;
		var hi = len - 1;  
		while (hi - lo > 1) {
			mid = Math.floor((lo + hi) / 2);
			if (arr[mid] <= num) {
				lo = mid;
			} else {
				hi = mid;
			}
		}
		return hi;
	}
	
	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			i = closest(target, untils);
			if (i >= 0) {
				return i;
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			lastOffset = last.offset,
			offsets = [last],
			change, next, nextOffset, i;

		for (i = 1; i < 48; i++) {
			nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
			if (nextOffset !== lastOffset) {
				// Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
				next = new OffsetAt(new Date(startYear, i, 1));
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				last = next;
				lastOffset = nextOffset;
			}
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			checkedOffsets = {},
			i, j, offset, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			offset = offsets[i].offset;
			if (checkedOffsets.hasOwnProperty(offset)) {
				continue;
			}
			guessesOffset = guesses[offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
			checkedOffsets[offset] = true;
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			out  = moment.utc.apply(null, args),
			zone;

		if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),

/***/ 1569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8838);
/* harmony import */ var _ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9830);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_icons_material_ArrowForwardIos__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6176);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7572);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4538);
/* harmony import */ var _utils_tournaments__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3722);
/* harmony import */ var _context_UIContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6849);
/* harmony import */ var _utils_time__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8398);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_8__);














var TabsOptionsPro;
(function(TabsOptionsPro) {
    TabsOptionsPro["Season_3"] = "Season 3";
    TabsOptionsPro["Season_2"] = "Season 2";
    TabsOptionsPro["Season_1"] = "Season 1";
})(TabsOptionsPro || (TabsOptionsPro = {}));
var TabsOptionsAmateur;
(function(TabsOptionsAmateur) {
    TabsOptionsAmateur["All"] = "All";
    TabsOptionsAmateur["Free"] = "Free";
    TabsOptionsAmateur["Premium"] = "Premium";
})(TabsOptionsAmateur || (TabsOptionsAmateur = {}));
var ConditionalLinkWrapper = function(param) {
    var condition = param.condition, wrapper = param.wrapper, children = param.children;
    return condition ? wrapper(children) : children;
};
var ScheduleList = function(param) {
    var firstSeasonTournaments = param.firstSeasonTournaments, secondSeasonTournaments = param.secondSeasonTournaments, thirdSeasonTournaments = param.thirdSeasonTournaments, amFreeTournaments = param.amFreeTournaments, amPremiumTournaments = param.amPremiumTournaments, amAllTournaments = param.amAllTournaments, isAmateur = param.isAmateur;
    var ref;
    var dispatch = (0,_context_UIContext__WEBPACK_IMPORTED_MODULE_6__/* .useUI */ .l)().dispatch;
    var isDesktop = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__/* .useWindowSize */ .i)().isDesktop;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isFirstRender = ref1[0], setIsFirstRender = ref1[1];
    var tabsOptionsType = isAmateur ? TabsOptionsAmateur : TabsOptionsPro;
    var tabs = Object.keys(tabsOptionsType).map(function(key) {
        return {
            label: tabsOptionsType[key],
            value: key
        };
    });
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(tabs[0].value), selectedTab = ref2[0], setSelectedTab = ref2[1];
    var previousWinner = null; //TODO add this part when needed
    var _obj, _obj1;
    var tournamentsByTab = isAmateur ? (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, TabsOptionsAmateur.All, amAllTournaments), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, TabsOptionsAmateur.Free, amFreeTournaments), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, TabsOptionsAmateur.Premium, amPremiumTournaments), _obj) : (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj1, TabsOptionsPro.Season_3, thirdSeasonTournaments), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj1, TabsOptionsPro.Season_2, secondSeasonTournaments), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj1, TabsOptionsPro.Season_1, firstSeasonTournaments), _obj1);
    var defaultTabBySelected = function() {
        var ref;
        var tabBySelected = (ref = tabs === null || tabs === void 0 ? void 0 : tabs.find(function(t) {
            return t.value === selectedTab;
        })) === null || ref === void 0 ? void 0 : ref.label;
        if (!tabBySelected) {
            return isAmateur ? TabsOptionsAmateur.All : TabsOptionsPro.Season_2;
        }
        return tabBySelected;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isFirstRender) {
            setIsFirstRender(false);
        }
    }, []);
    var isJoinAvailable = function(tournament) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var isFinalSeason3 = (tournament === null || tournament === void 0 ? void 0 : tournament.season) === 3 && ((ref1 = tournament === null || tournament === void 0 ? void 0 : (ref = tournament.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.includes("final"));
        if (!tournament.signUpStartTime || !tournament.signUpEndTime || isFinalSeason3) return false;
        var signupStart = dayjs__WEBPACK_IMPORTED_MODULE_8___default()(tournament.signUpStartTime);
        var signupEnd = dayjs__WEBPACK_IMPORTED_MODULE_8___default()(tournament.signUpEndTime);
        var currentDate = dayjs__WEBPACK_IMPORTED_MODULE_8___default()();
        return (tournament === null || tournament === void 0 ? void 0 : (ref2 = tournament.versionInfo) === null || ref2 === void 0 ? void 0 : ref2.state) !== "DRAFT" && currentDate.isAfter(signupStart) && currentDate.isBefore(signupEnd) && (0,_utils_tournaments__WEBPACK_IMPORTED_MODULE_5__/* .isPossibleToJoin */ .Oq)((tournament === null || tournament === void 0 ? void 0 : (ref3 = tournament.participants) === null || ref3 === void 0 ? void 0 : ref3.allInvitationsCount) - (tournament === null || tournament === void 0 ? void 0 : (ref4 = tournament.participants) === null || ref4 === void 0 ? void 0 : ref4.declinedCount) - (tournament === null || tournament === void 0 ? void 0 : (ref5 = tournament.participants) === null || ref5 === void 0 ? void 0 : ref5.withdrawnCount));
    };
    var viewVariants = {
        initial: {
            opacity: isDesktop ? 1 : 0.5,
            transform: isDesktop ? "translate(0, 0)" : "translate(0, 4rem)"
        },
        view: {
            opacity: 1,
            transform: "translate(0, 0)"
        }
    };
    var hoverVariants = {
        initial: {
            backgroundColor: "linear-gradient(90deg,rgba(97, 97, 97, 0.2) 0%,rgba(97, 97, 97, 0) 100.09%),#141414"
        },
        hover: {
            backgroundColor: "#212121"
        }
    };
    var hoverVariantsPga = {
        initial: {
            backgroundColor: "linear-gradient(90deg,rgba(0, 83, 255, 0.5) 0%,rgba(0, 83, 255, 0) 100.09%),#00205b"
        },
        hover: {
            backgroundColor: "#0053ff",
            opacity: 1
        }
    };
    if (isFirstRender) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: isAmateur ? (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleList) : "",
        children: [
            !isAmateur && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleTabs),
                children: tabs.map(function(tab) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: function() {
                            return setSelectedTab(tab.value);
                        },
                        className: "".concat((_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleTab), " ").concat(tab.value === selectedTab ? (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleTabActive) : ""),
                        children: tab.label
                    }, tab.value);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .motion.section */ .E.section, {
                className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleCards),
                viewport: {
                    once: true
                },
                variants: viewVariants,
                whileInView: "view",
                initial: "initial",
                transition: {
                    ease: "easeInOut",
                    duration: 0.8
                },
                children: (ref = tournamentsByTab[defaultTabBySelected()]) === null || ref === void 0 ? void 0 : ref.map(function(tournament) {
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    var signupUri = !!(tournament === null || tournament === void 0 ? void 0 : (ref = tournament.locationsConfiguration) === null || ref === void 0 ? void 0 : ref.length) && (tournament === null || tournament === void 0 ? void 0 : tournament.locationsConfiguration[0].paymentUrl);
                    var isElevated = (0,_utils_tournaments__WEBPACK_IMPORTED_MODULE_5__/* .isElevatedRound */ .bN)(tournament.season, tournament.name);
                    var isFinalSeason2 = tournament.season === 2 && ((ref2 = (ref1 = tournament.name) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === null || ref2 === void 0 ? void 0 : ref2.includes("final"));
                    var isFinalSeason3 = tournament.season === 3 && ((ref4 = (ref3 = tournament.name) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === null || ref4 === void 0 ? void 0 : ref4.includes("final"));
                    var isPremiumAmateurRound = (0,_utils_tournaments__WEBPACK_IMPORTED_MODULE_5__/* .isPremiumAmateur */ .kL)(tournament);
                    var isPGATournament = tournament.id === _utils_constants__WEBPACK_IMPORTED_MODULE_12__/* .PGA_TOURNAMENT_ID */ .fD;
                    var getPurse = function() {
                        var ref, ref1, ref2;
                        if (isPGATournament) {
                            var ref3, ref4, ref5;
                            return _utils_constants__WEBPACK_IMPORTED_MODULE_12__/* .INITIAL_PURSE_PGA */ .X9 + _utils_constants__WEBPACK_IMPORTED_MODULE_12__/* .ENTRY_FEE_PGA */ .m6 * ((tournament === null || tournament === void 0 ? void 0 : (ref3 = tournament.participants) === null || ref3 === void 0 ? void 0 : ref3.allInvitationsCount) - (tournament === null || tournament === void 0 ? void 0 : (ref4 = tournament.participants) === null || ref4 === void 0 ? void 0 : ref4.declinedCount) - (tournament === null || tournament === void 0 ? void 0 : (ref5 = tournament.participants) === null || ref5 === void 0 ? void 0 : ref5.withdrawnCount));
                        }
                        if (isFinalSeason3) return _utils_constants__WEBPACK_IMPORTED_MODULE_12__/* .INITIAL_PURSE_SEASON_3_FINAL */ .hm;
                        if (isFinalSeason2) return _utils_constants__WEBPACK_IMPORTED_MODULE_12__/* .INITIAL_PURSE */ .DW;
                        return (isElevated ? _utils_constants__WEBPACK_IMPORTED_MODULE_12__/* .INITIAL_PURSE_ELEVATED */ .ln : _utils_constants__WEBPACK_IMPORTED_MODULE_12__/* .INITIAL_PURSE */ .DW) + _utils_constants__WEBPACK_IMPORTED_MODULE_12__/* .ENTRY_FEE */ .Uh * ((tournament === null || tournament === void 0 ? void 0 : (ref = tournament.participants) === null || ref === void 0 ? void 0 : ref.allInvitationsCount) - (tournament === null || tournament === void 0 ? void 0 : (ref1 = tournament.participants) === null || ref1 === void 0 ? void 0 : ref1.declinedCount) - (tournament === null || tournament === void 0 ? void 0 : (ref2 = tournament.participants) === null || ref2 === void 0 ? void 0 : ref2.withdrawnCount));
                    };
                    var isPublishedTournament = (tournament === null || tournament === void 0 ? void 0 : (ref5 = tournament.versionInfo) === null || ref5 === void 0 ? void 0 : ref5.state) !== "DRAFT";
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .motion.div */ .E.div, {
                        className: "".concat((_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleCard)).concat(isPGATournament ? " " + (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleCardPga) : ""),
                        variants: isPGATournament ? hoverVariantsPga : hoverVariants,
                        whileHover: isPublishedTournament ? "hover" : {},
                        transition: {
                            ease: "linear",
                            duration: 0.3
                        },
                        style: {
                            cursor: isPublishedTournament ? "pointer" : "default"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ConditionalLinkWrapper, {
                                condition: isPublishedTournament,
                                wrapper: function(children) {
                                    var ref;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        href: "".concat(isAmateur ? "/amateur" : "", "/tournament/").concat((ref = tournament.name) === null || ref === void 0 ? void 0 : ref.replace(/:/g, "").replace(/ - /g, " ").replace(/\//g, "-").replace(/#/g, "").split(" ").join("-").toLowerCase()),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "".concat((_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleCardLink)).concat(isPGATournament ? " " + (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleCardLinkPga) : ""),
                                            children: children
                                        })
                                    });
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "".concat((_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleCardWrapper), " ").concat(!isPublishedTournament ? (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().inactiveColor) : ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleCardHeadline),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleCardDate),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: (0,_utils_time__WEBPACK_IMPORTED_MODULE_7__/* .utcTimeLocal */ .V)(tournament.startDate, "MMM. D, H:mm z")
                                                        }),
                                                        " - ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: (0,_utils_time__WEBPACK_IMPORTED_MODULE_7__/* .utcTimeLocal */ .V)(tournament.endDate, "MMM. D, H:mm z")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleCardTitle),
                                                    children: tournament.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleCardInfo),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "".concat((_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().schedulePurse), " ").concat(!isAmateur && isElevated || isAmateur && isPremiumAmateurRound ? (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().brandColor) : ""),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().schedulePurseTitle),
                                                            children: isAmateur ? "Entry fee" : "Purse"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().schedulePurseAmount),
                                                            children: isAmateur ? (0,_utils_tournaments__WEBPACK_IMPORTED_MODULE_5__/* .isFreeAmateur */ .zQ)(tournament) ? "Free" : "$10" : "$".concat(getPurse().toLocaleString("en-US"))
                                                        })
                                                    ]
                                                }),
                                                previousWinner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleWinner),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleWinnerImg),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                                src: "",
                                                                layout: "fill",
                                                                objectFit: "contain",
                                                                alt: "winner image"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().scheduleWinnerInfo),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().schedulePurseTitle),
                                                                    children: "Previous winner"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: "WINNER"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            isJoinAvailable(tournament) && signupUri && !isAmateur && !isPGATournament && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "".concat((_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().cardBoxText), " ").concat((_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().orange), " ").concat((_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().cta)),
                                onClick: function() {
                                    window.localStorage.setItem("next_signup_uri", signupUri);
                                    dispatch({
                                        type: "toggleJoinFlowInfoModal",
                                        payload: {
                                            isOpen: true,
                                            title: tournament.name,
                                            modalType: "signup"
                                        }
                                    });
                                },
                                children: isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "".concat((_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().joinLink), " ").concat((_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().joinLinkText)),
                                    children: "Join"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ArrowForwardIos__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                    className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().joinLink)
                                })
                            }),
                            isAmateur && (0,_utils_tournaments__WEBPACK_IMPORTED_MODULE_5__/* .isPossibleToJoinAM */ .kn)(tournament.endDate, isPublishedTournament) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://portal.trackmangolf.com/player/tournaments/".concat(tournament.id),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "".concat((_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().joinLink), " ").concat((_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().joinLinkText)),
                                    children: "Join"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ArrowForwardIos__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                    className: (_ScheduleList_module_css__WEBPACK_IMPORTED_MODULE_10___default().joinLink)
                                })
                            })
                        ]
                    }, tournament.id);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScheduleList);


/***/ }),

/***/ 8398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ utcTimeLocal; }
/* harmony export */ });
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_0__);

var utcTimeLocal = function(date, template) {
    var zoneName = moment_timezone__WEBPACK_IMPORTED_MODULE_0___default().tz.guess();
    var currentTime = moment_timezone__WEBPACK_IMPORTED_MODULE_0___default().utc(date).tz(zoneName);
    return currentTime.format(template);
};


/***/ }),

/***/ 5766:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"scheduleGridWrapper":"Schedule_scheduleGridWrapper__JVjnD","tournamentOverviewLayout":"Schedule_tournamentOverviewLayout__iekio"};

/***/ }),

/***/ 8838:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"scheduleList":"ScheduleList_scheduleList__qsOsM","joinLink":"ScheduleList_joinLink__I8OJa","joinLinkText":"ScheduleList_joinLinkText__6MDh1","scheduleTabs":"ScheduleList_scheduleTabs__ay3jQ","scheduleTab":"ScheduleList_scheduleTab__5NBTY","scheduleTabActive":"ScheduleList_scheduleTabActive__8c_p8","scheduleCards":"ScheduleList_scheduleCards__dMJet","scheduleCard":"ScheduleList_scheduleCard__7AHGA","scheduleCardPga":"ScheduleList_scheduleCardPga__ARN1A","scheduleCardLinkPga":"ScheduleList_scheduleCardLinkPga__IrRdG","scheduleCardWrapper":"ScheduleList_scheduleCardWrapper__FHAeF","scheduleCardHeadline":"ScheduleList_scheduleCardHeadline__Eqsxh","scheduleCardDate":"ScheduleList_scheduleCardDate__y_qFN","scheduleCardTitle":"ScheduleList_scheduleCardTitle__6KSne","scheduleCardInfo":"ScheduleList_scheduleCardInfo__vtahn","schedulePurse":"ScheduleList_schedulePurse___wV4x","schedulePurseTitle":"ScheduleList_schedulePurseTitle__thAW7","schedulePurseAmount":"ScheduleList_schedulePurseAmount__cJSt5","scheduleWinner":"ScheduleList_scheduleWinner__G5ICG","scheduleWinnerInfo":"ScheduleList_scheduleWinnerInfo__uoX6b","scheduleWinnerImg":"ScheduleList_scheduleWinnerImg__LRWk3","brandColor":"ScheduleList_brandColor__6Swn1","inactiveColor":"ScheduleList_inactiveColor__Hds_x"};

/***/ })

}]);